import { render, staticRenderFns } from "./formItem.vue?vue&type=template&id=10da1c9b&scoped=true&"
import script from "./formItem.vue?vue&type=script&lang=js&"
export * from "./formItem.vue?vue&type=script&lang=js&"
import style0 from "./formItem.vue?vue&type=style&index=0&id=10da1c9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da1c9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10da1c9b')) {
      api.createRecord('10da1c9b', component.options)
    } else {
      api.reload('10da1c9b', component.options)
    }
    module.hot.accept("./formItem.vue?vue&type=template&id=10da1c9b&scoped=true&", function () {
      api.rerender('10da1c9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/createform/components/formItem/formItem.vue"
export default component.exports